import { NotificationEventContent } from "../../components/organisms/NotificationEventContent";
import { MoreTemplates } from "../../components/template/MoreTemplates";
const NotificationEventPage = () => {
  return (
    <MoreTemplates pageTitle="공지/이벤트" pageHeaderTitle="설정" padding="0">
      <NotificationEventContent />
    </MoreTemplates>
  );
};

export default NotificationEventPage;
